<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Gypsy</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="ded"><span>For Steele Curry whose inherent kindness<br/>and boundless enthusiasm are much appreciated.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2cb25464